import { useQuery } from "@tanstack/react-query";

import { getGroups } from "../services/group.services";
import { Group } from "../types/group.types";
import { GROUPS_QUERY_KEYS } from "../queryKeys";

export const useGroupsListQuery = (entityId: number | null | undefined) => {
  return useQuery<Group[]>({
    queryKey: GROUPS_QUERY_KEYS.groupsList(entityId),
    queryFn: () => getGroups(entityId),
    enabled: !!entityId,
    staleTime: 1000 * 60 * 5,
  });
};
